function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/assertThisInitialized.js
// module id = 235
// module chunks = 35783957827783 114276838955818